module.exports = __webpack_public_path__ + "media/svg-new/svg-cancel-e0af04a0.svg";